import * as React from 'react';
export const cloudflareSvg = React.forwardRef(function cloudflareSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F4F7FA',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm19.633 20.379.1-.354c.123-.418.077-.808-.126-1.092-.187-.262-.498-.416-.876-.435l-7.157-.091a.14.14 0 0 1-.113-.06.145.145 0 0 1-.014-.13.191.191 0 0 1 .165-.128l7.222-.091c.857-.039 1.783-.739 2.108-1.59l.412-1.082a.237.237 0 0 0 .017-.092.283.283 0 0 0-.005-.05 4.703 4.703 0 0 0-4.586-3.695 4.708 4.708 0 0 0-4.455 3.206 2.114 2.114 0 0 0-1.486-.413 2.123 2.123 0 0 0-1.834 2.643 3.018 3.018 0 0 0-2.889 3.459c.01.07.07.12.139.12l13.21.002h.005a.176.176 0 0 0 .163-.127Z',
      fill: '#F6821F',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M22.018 15.405c-.067 0-.132.003-.2.005a.066.066 0 0 0-.03.007.115.115 0 0 0-.072.077l-.283.977c-.122.418-.076.808.127 1.092.187.262.498.416.877.435l1.524.092a.135.135 0 0 1 .108.06.145.145 0 0 1 .017.13.191.191 0 0 1-.165.127l-1.585.091c-.86.041-1.788.739-2.114 1.59l-.115.3a.085.085 0 0 0 .075.116h5.46a.149.149 0 0 0 .14-.105 3.87 3.87 0 0 0 .147-1.066c0-2.167-1.752-3.928-3.911-3.928Z',
      fill: '#FBAD41',
    }),
  );
});
cloudflareSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var cloudflare = {
  category: 'brand',
  colorable: false,
  name: 'cloudflare',
  svg: cloudflareSvg,
};
